import { useAppDisplayModeContext } from '@archipro-design/aria';
import { PlusIcon } from 'lucide-react';
import { Button as RoccoButton } from '@archipro/rocco/components/button';

interface FilterBarNewBoardButtonProps {
    onClick?: () => void;
}

const FilterBarNewBoardButton = ({ onClick }: FilterBarNewBoardButtonProps) => {
    const { mobile } = useAppDisplayModeContext();

    const onCreateNewBoard = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        onClick?.();
    };

    return (
        <RoccoButton
            color="dark"
            onClick={onCreateNewBoard}
            shape="square"
            weight="normal"
        >
            <PlusIcon className="w-4 h-4 mr-2" />
            {mobile ? 'New Board' : 'NEW BOARD'}
        </RoccoButton>
    );
};

export default FilterBarNewBoardButton;
